import { WinFormsContentScreen } from '@winforms';
import { SubnaviDropDownService } from '@navigation';
import { __asyncI18n } from '@localisation';
import { RoutingEntry } from '@routing';
import { DummySiteComponent } from '@site-info';
import { ApplicationSetNaviExtension, getRoutes } from '@application-sets';


export function getApplicationSetRoutes(type) : Array<RoutingEntry> {
    return [
        {
            path: 'CreateNewApplicationSet',
            component: WinFormsContentScreen,
            data: {
                title: __asyncI18n('Create new Application', 'subnavi.application.settings'),

                contentRoute: (type === 'System')
                    ? '/Site/ApplicationSet/Settings?isSystemApplicationSet=true'
                    : (type === 'Tenant')
                        ? '/Site/ApplicationSet/Settings?isTenantApplicationSet=true'
                        : '/Site/ApplicationSet/Settings',

                testId: 'sidenavigation.link.create-new-applications-set',
                dontShowInSubNavigation: true
            }
        },
        {
            path: 'CreateApplicationSetFromTemplate',
            component: WinFormsContentScreen,
            data: {
                title: __asyncI18n('Create from template', 'subnavi.application.create-from-template'),
                contentRoute: (type === 'System')
                    ? '/Site/ApplicationSet/CreateApplicationSetFromTemplate?isSystemApplicationSet=true'
                    : (type === 'Tenant')
                        ? '/Site/ApplicationSet/CreateApplicationSetFromTemplate?isTenantApplicationSet=true'
                        : '/Site/ApplicationSet/CreateApplicationSetFromTemplate',

                testId: 'sidenavigation.link.create-applications-set-from-template',
                dontShowInSubNavigation: true
            }
        },
        {
            path: ':applicationsetid',
            data: {
                title: ':applicationsetid | applicationSetIdToName',
                dontShowInSubNavigation: true,
                showSubNaviLevel: 3,
                //showChildrenAsSecondLevel: true,
                breadCrumbDropDown: SubnaviDropDownService,
                dynamicChildren: ApplicationSetNaviExtension,
                favouritesRouteColor: 'natural-green-light',
                favouritesRouteCaption: '[ApplicationSetName] / [PageName]',
                redirectTo: 'ApplicationSet/' + type + '/:applicationsetid/*firstChild'
            // redirectTo: '/Site/ApplicationSet'
            },

            children: [
                {
                    path: '',
                    component: DummySiteComponent,
                    data: {
                        title: ':applicationsetid | applicationSetIdToName',
                        showSubNaviLevel: 3,
                        dontShowInSubNavigation: true,
                        breadCrumbDropDown: SubnaviDropDownService,
                        dynamicChildren: ApplicationSetNaviExtension,
                        favouritesRouteColor: 'natural-green-light',
                        redirectTo: 'ApplicationSet/' + type + '/:applicationsetid/*firstChild',
                        favouritesRouteCaption: '[ApplicationSetName] / [PageName]',
                    }
                },
                {
                    path : ':version',
                    data : {
                        title: 'version',
                        showChildrenAsSecondLevel: true,
                        dontShowInSubNavigation: true,
                        redirectTo: 'ApplicationSet/' + type + '/:applicationsetid/:applicationsetid/*firstChild',
                        showSubNaviLevel: 3
                    },
                    children: [...getRoutes(':applicationsetid')]
                }
            ]
        }
    ];
}

